'use client'

import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const SvgGooglePlayStoreIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 126 40",
    role: "img",
    ref,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "rect",
        {
          width: 125,
          height: 39,
          x: 0.5,
          y: 0.5,
          fill: "#000",
          stroke: "#CCC",
          rx: 5.5
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M44.549 10.377q0 1.256-.7 2.003-.798.888-2.073.888-1.222 0-2.076-.901-.856-.9-.855-2.233 0-1.333.855-2.234.854-.9 2.076-.9.605 0 1.157.251.553.252.883.67l-.496.528q-.56-.712-1.544-.712-.891 0-1.541.666-.65.667-.65 1.731t.65 1.73 1.541.666q.945 0 1.576-.67.41-.436.472-1.215h-2.048v-.721h2.733q.04.235.04.453",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "#fff",
          strokeWidth: 0.2,
          d: "M44.549 10.377q0 1.256-.7 2.003-.798.888-2.073.888-1.222 0-2.076-.901-.856-.9-.855-2.233 0-1.333.855-2.234.854-.9 2.076-.9.605 0 1.157.251.553.252.883.67l-.496.528q-.56-.712-1.544-.712-.891 0-1.541.666-.65.667-.65 1.731t.65 1.73 1.541.666q.945 0 1.576-.67.41-.436.472-1.215h-2.048v-.721h2.733q.04.235.04.453ZM48.883 7.871h-2.569v1.902h2.316v.721h-2.316v1.902h2.57v.738h-3.295v-6h3.294zM51.94 13.134h-.725V7.87H49.64v-.737h3.877v.737H51.94zM56.321 13.134h.725v-6h-.725zM60.261 13.134h-.725V7.87H57.96v-.737h3.877v.737h-1.576z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "m65.575 11.856-.074.068zm3.065-3.444-.073.068zm-3.065 0-.074-.068zm3.601 3.946.074.067zm-4.136 0 .074-.067zm0-4.449.073.068zm4.132.004.074-.067zm-3.67 4.011q.655.706 1.606.706v-.2a1.91 1.91 0 0 1-1.46-.642zm1.606.706a2.1 2.1 0 0 0 1.605-.706l-.146-.136a1.91 1.91 0 0 1-1.46.642zm1.605-.706q.655-.708.654-1.79h-.2q-.001 1.012-.6 1.654zm.654-1.79c0-.72-.217-1.32-.654-1.79l-.146.136q.599.641.6 1.654zm-.654-1.79a2.11 2.11 0 0 0-1.605-.707v.2q.861-.001 1.459.643zm-1.605-.707a2.11 2.11 0 0 0-1.607.707l.147.136a1.91 1.91 0 0 1 1.46-.643zm-1.607.707c-.436.47-.652 1.07-.652 1.79h.2q.001-1.013.6-1.654zm-.652 1.79q-.001 1.082.652 1.79l.147-.136c-.397-.429-.6-.978-.6-1.654zm4.253 2.156a2.59 2.59 0 0 1-1.995.878v.2q1.281 0 2.143-.943zm-1.995.878q-1.193.001-1.993-.877l-.148.134a2.78 2.78 0 0 0 2.142.943zm-1.993-.877c-.537-.587-.805-1.303-.805-2.157h-.2q-.001 1.352.857 2.291zm-.805-2.157q0-1.28.805-2.157l-.148-.136c-.573.626-.857 1.393-.857 2.293zm.805-2.158a2.59 2.59 0 0 1 1.993-.876v-.2q-1.28 0-2.141.942zm1.993-.876c.792 0 1.453.292 1.992.88l.147-.135q-.865-.944-2.138-.945zm1.992.88c.538.59.808 1.305.808 2.154h.2q0-1.344-.86-2.288zm.808 2.154q0 1.279-.805 2.156l.148.136q.858-.94.857-2.292z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "#fff",
          strokeWidth: 0.2,
          d: "M71.025 13.134v-6h.882l2.742 4.667h.031l-.032-1.156V7.134h.726v6h-.756L71.75 8.24h-.032l.032 1.157v3.737z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M100.513 30.134h1.754V17.633h-1.754zm15.804-7.998-2.011 5.42h-.061l-2.087-5.42h-1.89l3.13 7.575-1.785 4.214h1.83l4.825-11.79zm-9.95 6.578c-.576 0-1.377-.306-1.377-1.062 0-.964.998-1.335 1.86-1.335.772 0 1.134.178 1.603.418-.136 1.159-1.074 1.979-2.086 1.979m.211-6.852c-1.27 0-2.587.596-3.13 1.914l1.557.692c.333-.692.953-.917 1.603-.917.908 0 1.83.579 1.845 1.608v.129c-.318-.193-.999-.482-1.83-.482-1.678 0-3.388.98-3.388 2.814 0 1.673 1.377 2.75 2.92 2.75 1.179 0 1.829-.562 2.238-1.222h.06v.965h1.694V25.32c0-2.22-1.558-3.458-3.569-3.458m-10.843 1.796h-2.496v-4.285h2.496c1.311 0 2.056 1.154 2.056 2.142 0 .969-.745 2.143-2.056 2.143m-.046-6.026h-4.204v12.502h1.754v-4.736h2.45c1.945 0 3.857-1.498 3.857-3.883s-1.912-3.883-3.857-3.883M72.765 28.716c-1.212 0-2.227-1.08-2.227-2.561 0-1.5 1.015-2.594 2.227-2.594 1.197 0 2.136 1.095 2.136 2.594 0 1.482-.939 2.56-2.136 2.56m2.014-5.88h-.06c-.394-.5-1.15-.951-2.105-.951-2 0-3.833 1.869-3.833 4.27 0 2.384 1.833 4.237 3.833 4.237.954 0 1.711-.451 2.105-.967h.06v.612c0 1.628-.817 2.497-2.135 2.497-1.076 0-1.743-.821-2.015-1.514l-1.53.677c.439 1.127 1.606 2.513 3.545 2.513 2.06 0 3.802-1.29 3.802-4.431v-7.636h-1.667zm2.878 7.298h1.758V17.633h-1.758zm4.348-4.124c-.045-1.644 1.197-2.481 2.092-2.481.695 0 1.287.37 1.483.902zm5.454-1.418c-.333-.95-1.348-2.707-3.424-2.707-2.06 0-3.772 1.724-3.772 4.254 0 2.384 1.697 4.253 3.97 4.253 1.833 0 2.893-1.192 3.332-1.885l-1.363-.967c-.455.709-1.076 1.176-1.97 1.176s-1.53-.435-1.939-1.29l5.348-2.351zM44.855 23.19v1.804h4.06c-.122 1.015-.44 1.756-.924 2.27-.591.63-1.516 1.323-3.136 1.323-2.5 0-4.454-2.143-4.454-4.801s1.954-4.802 4.454-4.802c1.349 0 2.333.564 3.06 1.29l1.197-1.273c-1.016-1.031-2.364-1.821-4.257-1.821-3.424 0-6.303 2.965-6.303 6.606s2.879 6.605 6.303 6.605c1.848 0 3.241-.645 4.332-1.853 1.12-1.192 1.47-2.868 1.47-4.221 0-.418-.03-.805-.091-1.127zm10.417 5.525c-1.211 0-2.257-1.063-2.257-2.577 0-1.531 1.046-2.578 2.257-2.578s2.257 1.047 2.257 2.578c0 1.514-1.045 2.577-2.257 2.577m0-6.831c-2.212 0-4.014 1.789-4.014 4.254 0 2.449 1.802 4.253 4.014 4.253 2.211 0 4.015-1.804 4.015-4.253 0-2.465-1.804-4.254-4.015-4.254m8.758 6.83c-1.212 0-2.258-1.062-2.258-2.576 0-1.531 1.046-2.578 2.258-2.578s2.256 1.047 2.256 2.578c0 1.514-1.044 2.577-2.256 2.577m0-6.83c-2.212 0-4.014 1.789-4.014 4.254 0 2.449 1.802 4.253 4.014 4.253 2.211 0 4.014-1.804 4.014-4.253 0-2.465-1.803-4.254-4.014-4.254M48.883 7.871h-2.569v1.902h2.316v.721h-2.316v1.902h2.57v.738h-3.295v-6h3.294zM51.94 13.134h-.725V7.87H49.64v-.737h3.877v.737H51.94zM56.321 13.134h.725v-6h-.725zM60.261 13.134h-.725V7.87H57.96v-.737h3.877v.737h-1.576zM65.575 11.856q.626.674 1.532.674a2.01 2.01 0 0 0 1.533-.674q.627-.675.627-1.722 0-1.048-.627-1.722a2.01 2.01 0 0 0-1.532-.675 2.01 2.01 0 0 0-1.533.675q-.626.674-.626 1.722.001 1.047.626 1.722m3.601.502a2.69 2.69 0 0 1-2.068.91 2.68 2.68 0 0 1-2.068-.91q-.832-.909-.831-2.224 0-1.316.83-2.225A2.69 2.69 0 0 1 67.109 7q1.23 0 2.064.913t.835 2.221q0 1.315-.83 2.224M71.025 13.134v-6h.882l2.742 4.667h.031l-.032-1.156V7.134h.726v6h-.756L71.75 8.24h-.032l.032 1.157v3.737z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "mask",
        {
          id: "GooglePlayStoreIcon_svg__a",
          width: 13,
          height: 26,
          x: 8,
          y: 7,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "luminance"
          },
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M8.873 7.538c-.274.308-.436.786-.436 1.405V31.06c0 .62.162 1.097.436 1.404l.068.073 11.65-12.389v-.292L8.942 7.465z",
              clipRule: "evenodd"
            }
          )
        }
      ),
      /* @__PURE__ */ jsx("g", { mask: "url(#GooglePlayStoreIcon_svg__a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "url(#GooglePlayStoreIcon_svg__b)",
          fillRule: "evenodd",
          d: "M8.873 7.538c-.274.308-.436.786-.436 1.405V31.06c0 .62.162 1.097.436 1.404l.068.073 11.65-12.389v-.292L8.942 7.465z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx(
        "mask",
        {
          id: "GooglePlayStoreIcon_svg__c",
          width: 11,
          height: 10,
          x: 20,
          y: 15,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "luminance"
          },
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M20.592 19.855v.292l3.882 4.131.088-.052 4.601-2.78c1.315-.795 1.315-2.095 0-2.889l-4.6-2.78-.088-.053z",
              clipRule: "evenodd"
            }
          )
        }
      ),
      /* @__PURE__ */ jsx("g", { mask: "url(#GooglePlayStoreIcon_svg__c)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "url(#GooglePlayStoreIcon_svg__d)",
          fillRule: "evenodd",
          d: "M20.592 19.855v.292l3.882 4.131.088-.052 4.601-2.78c1.315-.795 1.315-2.095 0-2.889l-4.6-2.78-.088-.053z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx(
        "mask",
        {
          id: "GooglePlayStoreIcon_svg__e",
          width: 17,
          height: 13,
          x: 8,
          y: 20,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "luminance"
          },
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "M8.873 32.463c.432.488 1.148.549 1.954.062l13.736-8.3-3.971-4.224z",
              clipRule: "evenodd"
            }
          )
        }
      ),
      /* @__PURE__ */ jsx("g", { mask: "url(#GooglePlayStoreIcon_svg__e)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "url(#GooglePlayStoreIcon_svg__f)",
          fillRule: "evenodd",
          d: "M8.873 32.463c.432.488 1.148.549 1.954.062l13.736-8.3-3.971-4.224z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx(
        "mask",
        {
          id: "GooglePlayStoreIcon_svg__g",
          width: 17,
          height: 14,
          x: 8,
          y: 7,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "luminance"
          },
          children: /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#fff",
              fillRule: "evenodd",
              d: "m8.873 7.538 11.719 12.463 3.97-4.224-13.735-8.3c-.378-.229-.737-.337-1.054-.337-.362 0-.67.14-.9.398",
              clipRule: "evenodd"
            }
          )
        }
      ),
      /* @__PURE__ */ jsx("g", { mask: "url(#GooglePlayStoreIcon_svg__g)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "url(#GooglePlayStoreIcon_svg__h)",
          fillRule: "evenodd",
          d: "m8.873 7.538 11.719 12.463 3.97-4.224-13.735-8.3c-.378-.229-.737-.337-1.054-.337-.362 0-.67.14-.9.398",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#000",
          fillRule: "evenodd",
          d: "M24.475 24.132 10.826 32.38c-.763.46-1.446.43-1.884.01l-.07.075.07.072v-.001c.438.42 1.12.45 1.884-.01l13.736-8.301z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#000",
          fillRule: "evenodd",
          d: "M8.872 32.319c-.273-.308-.435-.786-.435-1.405v.146c0 .619.162 1.097.435 1.405l.07-.074zM29.163 21.299l-4.688 2.833.087.093 4.601-2.78c.657-.397.985-.92.985-1.443-.055.473-.389.937-.985 1.297",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "m10.826 7.623 18.337 11.08c.596.36.93.824.985 1.298.001-.523-.328-1.047-.985-1.444L10.826 7.477c-1.314-.794-2.39-.134-2.39 1.466v.146c0-1.6 1.076-2.26 2.39-1.466",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsxs("defs", { children: [
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "GooglePlayStoreIcon_svg__b",
            x1: 8.437,
            x2: 8.437,
            y1: 7.465,
            y2: 32.536,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#3EC6F2" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#45AFE3" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "GooglePlayStoreIcon_svg__d",
            x1: 20.592,
            x2: 20.592,
            y1: 15.724,
            y2: 24.278,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#FAA51A" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#FAC80F" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "GooglePlayStoreIcon_svg__f",
            x1: 8.521,
            x2: -7.858,
            y1: 13.526,
            y2: 39.455,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#FF3A44" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#C31162" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "GooglePlayStoreIcon_svg__h",
            x1: 8.873,
            x2: 8.873,
            y1: 7.14,
            y2: 20.001,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#63BE6B" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#4AB96A" })
            ]
          }
        )
      ] })
    ]
  }
);
const ForwardRef = forwardRef(SvgGooglePlayStoreIcon);
ForwardRef.displayName = "GooglePlayStoreIcon";

export { ForwardRef as default };
//# sourceMappingURL=GooglePlayStoreIcon.mjs.map
